import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {Animation, TimelineLite, TweenMax} from "gsap";
import {CreepyCarnivalTwoGameConfig} from "../CreepyCarnivalTwoGameConfig";
import {CreepyCarnivalTwoSoundConfig} from "../CreepyCarnivalTwoSoundConfig";
import {CreepyCarnivalTwoGameMode} from "../gamemode/CreepyCarnivalTwoGameMode";
import {CCTwoFreeSpinEntryEvents} from "../screen/freespinintro/CreepyCarnivalTwoFreespinIntroController";
import {CreepyCarnivalTwoParsedGameData} from "../server/data/CreepyCarnivalTwoParsedGameData";
import {CreepyCarnivalTwoParsedInitData} from "../server/data/CreepyCarnivalTwoParsedInitData";
import {CreepyCarnivalBulbsEvent} from "../utils/CCTwoBulb";
import {CCTReelAttentionView} from "./CCTReelAttentionView";

export class CCTwoReelStopPresentationController extends ReelStopPresentationController {
    private _view:CCTReelAttentionView;
    private freespinTriggeredThisSpin:boolean;
    private _hasBetWins:false | boolean;
    private _freeSpinLeft:number;
    private reelIdd:number;
    private extraFreespinsAwarded:number;
    private _currentMode:string;
    private _stickySymbols:boolean[] = [];
    private _respinSymbols:number[];
    private _lastRespinningId:number;
    private _scatterCount:number = 0;
    private _nearWinStates:boolean[];
    private _scatterPositions:any[] | undefined;
    private _nonScatterPositions:boolean[];
    private _currentScatterSpots:number[] = [];
    private _symbolWinStates:boolean[][];
    private _attentionStopIds:number;
    private scatterAnim:Animation;
    private _minNoOfScatterRequired = 0;
    private _isScatterHit = false;
    private _reelScatterSpots:number[] = [];
    private _nextMode:string;
    private _scatterWinCount:number = 0;
    private _wildAttentionCount:number = 0;
    private _wildAttentionSoundPlayedOnQuickStop:boolean = false;

    private _lastActiveId:number = 14;

    constructor(index:number, attention:string) {
        super(index, attention);
        this._view = new CCTReelAttentionView;
        this._nearWinStates = ArrayHelper.initArrayWithValues(5, (index:number) => false);
        this._nonScatterPositions = ArrayHelper.initArrayWithValues(CreepyCarnivalTwoGameConfig.instance.REELS_NUM, (index:number) => false);

        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, CCTwoFreeSpinEntryEvents.FRAME_ANIM_COMPLETED, (event:GameEvent) => this.onFrameAnimComplete());
        EventHandler.addEventListener(this, CCTwoFreeSpinEntryEvents.SCATTER_WIGGLE_ANIM, (event:GameEvent) => this.playWiggleOnScatterSpots(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.START, (event:GameEvent) => this.onSpinStart());
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, (event:GameEvent) => this.onAllReelsStopped());
    }

    public onReelBounce(data:IReelStoppedData):void {
        this.applyReelStopSound(data.reelId);
        if((this._attentionStopIds === data.reelId) || (data.reelId === CreepyCarnivalTwoGameConfig.instance.REELS_NUM - 1)) {
            this._view.stopNearWin();
            this._attentionStopIds = -1;
        }
        const timeline:TimelineLite = new TimelineLite();
        let sym:StateReelSymbol | null;

        sym = Reels.getSymbol(data.reelId, 0);
        if(sym!.symName === "W" || sym!.symName === "S") {
            timeline.add(() => this.applyChangeState(sym!));

            if(sym!.symName === "W") {
                if(!(this._currentMode === "STAR_SPIN" && (data.reelId === 4 || data.reelId === 10)) && !data.quickStop) {
                    switch(this._wildAttentionCount) {
                        case 1:
                            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.WILD_ATTENTION_2);
                            this._wildAttentionCount = 2;
                            break;
                        case 2:
                            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.WILD_ATTENTION_3);
                            this._wildAttentionCount = 3;
                            break;
                        case 3:
                            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.WILD_ATTENTION_4);
                            this._wildAttentionCount = 0;
                            break;
                        default:
                            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.WILD_ATTENTION);
                            this._wildAttentionCount = 1;
                            break;
                    }
                }
                if(!(this._currentMode === "STAR_SPIN") && data.quickStop && !this._wildAttentionSoundPlayedOnQuickStop) {
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.WILD_ATTENTION);

                    this._wildAttentionSoundPlayedOnQuickStop = true;
                }
            } else {
                this._scatterWinCount++;
                if(this._scatterWinCount === 3 && this._currentMode.indexOf("FREESPIN") == -1) { //MainGame)
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.SCATTER_ATTENTION_WIN);
                } else {
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.SCATTER_ATTENTION);
                }
            }
        }

        if(data.reelId === this._lastActiveId && this._nextMode !== CreepyCarnivalTwoGameMode.RESPIN && this._nextMode !== CreepyCarnivalTwoGameMode.RESPIN_FREESPIN) {
            this._scatterWinCount = 0;
        }

        timeline.play();

        //handling retrigger in respin and non winning
        if(data.reelId != 14 || this.extraFreespinsAwarded == 0) {
            if(this.extraFreespinsAwarded > 0) {
                if(this._hasBetWins && data.reelId === this._lastRespinningId) {
                    this.reelIdd = data.reelId;
                    this.playIntroAnimation();
                    return;
                } else if(data.reelId === this._lastRespinningId) { //last respin
                    this.reelIdd = data.reelId;
                    this.playIntroAnimation();
                    return;
                }
            }
            if(data.reelId === this._lastRespinningId && this._nextMode == CreepyCarnivalTwoGameMode.FREESPIN) {
                this._lastRespinningId = -1;
                this.changeStateBackToNormal(); //linewin+ scatter issue #198
            }
            this.dispatchCompleteEvent(data.reelId);
            return;
        }
        //if retrigger happens without winning scene , played after 14th reelbounce
        this.reelIdd = data.reelId;
        this.playIntroAnimation();
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(!data.active) {
            this.dispatchCompleteEvent(data.reelId);
        } else { // used this else part to fix #223; earlier the call to below method was without else block
            this.tryPlayScatterAttention(data.reelId, data.quickStop);
        }

        if(data.reelId === this._lastActiveId) {
            this.tryAnticipationStopSound();
        }
    }

    protected onSpinStart():void {
        SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.REEL_SPIN);
    }

    protected parseFeatureGameData(data:CreepyCarnivalTwoParsedGameData) {
        this._symbolWinStates = data.winPositions;
        this._reelScatterSpots = [];
        this._scatterPositions = data.scatterPositions;
        this._scatterPositions = this._scatterPositions ? this._scatterPositions.reduce((acc, currEl) => acc.concat(currEl), []) : [];
        for(let i = 0; i < this._scatterPositions!.length; i++) {
            this._scatterPositions![i] && this._reelScatterSpots.push(i);
        }
        this._scatterCount = 0;
        this._currentScatterSpots = [];
        this._nonScatterPositions = ArrayHelper.initArrayWithValues(CreepyCarnivalTwoGameConfig.instance.REELS_NUM, (index:number) => false);

        this.freespinTriggeredThisSpin = data.freespinTriggeredThisSpin;
        this.extraFreespinsAwarded = data.extraFreespinsAwarded();
        this._hasBetWins = data.betWins != null && data.betWins.length > 0;
        this._freeSpinLeft = data.freespinsLeft;
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        this._respinSymbols = [];

        this._wildAttentionSoundPlayedOnQuickStop = false;

        if(data.mode === CreepyCarnivalTwoGameMode.NORMAL) {
            this._lastActiveId = data.reels.length - 1;
        } else {
            for(let i:number = 0; i < this._stickySymbols.length; ++i) {
                if(this._stickySymbols[i]) {
                    this._lastActiveId = i;
                }
            }
        }

        if(data.nextMode !== CreepyCarnivalTwoGameMode.FREESPIN) {
            this._stickySymbols = data.respinPositions ? data.respinPositions.reduce((acc, currEl) => acc.concat(currEl), []) : [];
            this.calculateLastSpinningId(this._stickySymbols);
        }

        this._view.anticipationSoundPlayed = false;
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, SpinReelEvent.REEL_ON_NEAR_WIN, (event:GameEvent) => this.onReelNearWin(event.params[0]));
    }

    private tryAnticipationStopSound() {
        if((this._currentMode === CreepyCarnivalTwoGameMode.NORMAL || this._currentMode === CreepyCarnivalTwoGameMode.RESPIN) && this._view.anticipationSoundPlayed) {
            if(this._scatterCount === 2) {
                SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.ANTICIPATION_STOP);
            }
            SlotGame.sound.stopEffect(CreepyCarnivalTwoSoundConfig.instance.ANTICIPATION);
        }
    }

    private applyReelStopSound(reelId:number):void {
        switch(reelId) {
            case 2:
            case 5:
            case 8:
            case 11:
            case 14:
                SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.REEL_STOP);
                break;
        }
    }

    private tryPlayScatterAttention(reelId:number, isQuickStop:boolean) {
        let sym:StateReelSymbol | null;
        sym = Reels.getSymbol(reelId, 0);
        if(sym!.symName == "S" || this._reelScatterSpots.indexOf(reelId) !== -1) {
            this._scatterCount++;
            this._nonScatterPositions[reelId] = true;
            this._currentScatterSpots.push(reelId);
        }
        if(this._currentMode.indexOf("FREESPIN") == -1) { //Main game
            this._minNoOfScatterRequired = 3;
            if(this._scatterCount == 2 && reelId == this._currentScatterSpots[this._currentScatterSpots.length - 1]) { //when scatter hits 2

                EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.SHOW_WIN_ATTENTION_BULBS));

            }
            if((reelId == 14 || reelId == this._lastRespinningId) && this._scatterCount < 3) {//if(!this._hasBetWins)
                EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.HIDE_ALL_FREE_SPIN_BULBS));
                EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.HIDE_WIN_ATTENTION_BULBS));

            }
        } else {//Free game
            this._minNoOfScatterRequired = 2;
        }

        if(this._scatterCount === this._minNoOfScatterRequired && reelId == this._currentScatterSpots[this._currentScatterSpots.length - 1]) { ////when scatter hits 3
            this._isScatterHit = true;
            this.playWiggleOnScatterSpots(this._currentScatterSpots);
            EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.SHOW_ALL_FREE_SPIN_BULBS));
            EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.HIDE_WIN_ATTENTION_BULBS));
        }
        if(!GameSetting.isFastSpin && !isQuickStop && this._scatterCount > 1) { // added quick stop and fast spin check for #219
            this.addAllNoWinSymbolsToTimeline(reelId);
        }
        if((reelId == 14 || reelId === this._lastRespinningId) && this._isScatterHit) { // to dim the non-scatter symbols after last stopped respinned reel
            this._isScatterHit = false;
            this.addAllNoWinSymbolsToTimeline(CreepyCarnivalTwoGameConfig.instance.REELS_NUM);
        }
    }

    private playWiggleOnScatterSpots(scatterSpots:number[]) {
        for(let i = 0; i < scatterSpots.length; i++) {
            let scatter = Reels.getSymbol(scatterSpots[i], 0);
            scatter!.skew.set(-0.1, 0);
            scatter!.alpha = 1;
            scatter && this.playScatterWiggle(scatter);
        }
    }

    private addAllNoWinSymbolsToTimeline(reelId:number):void {
        const timeline:TimelineLite = new TimelineLite();
        let noWinSymbol:StateReelSymbol | null;

        for(let k:number = 0; k < reelId; k++) {
            if(!this._nonScatterPositions[k]) {
                noWinSymbol = Reels.getSymbol(k, 0);
                if(noWinSymbol == null || !noWinSymbol.visible && noWinSymbol.symName == "S") {
                    continue;
                }
                noWinSymbol.alpha = 0.35;
                timeline.add(
                    noWinSymbol.changeState({
                        state : GameConfig.instance.SYMBOL_STATES.noWin!
                    }), 0);
            }
        }
    }

    private playScatterWiggle(scatter:StateReelSymbol) {
        this.scatterAnim = TweenMax.fromTo(scatter.skew, 0.2, {
            x : -0.1
        }, {
            x : 0.1,
            yoyo : true,
            repeat : 4,
            onComplete : () => {
                scatter.skew.set(0, 0);

            }
        });


        this.scatterAnim.play();
    }

    private onReelNearWin(reelId:number):void {
        this._view.playNearWin(reelId);
        this._attentionStopIds = reelId;
    }

    private changeStateBackToNormal() {
        for(let k:number = 0; k < CreepyCarnivalTwoGameConfig.instance.REELS_NUM; k++) {
            let sym = Reels.getSymbol(k, 0);
            if(sym) {
                sym!.alpha = 1;
            }
        }
    }

    private playIntroAnimation() {
        const timeline:TimelineLite = new TimelineLite();

        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(CCTwoFreeSpinEntryEvents.SHOW_FREE_SPIN_WON, this.extraFreespinsAwarded.toString()));
            EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.BLINKING_EFFECT_BULBS));
        }, 0.5);

        timeline.play();
    }

    private onFrameAnimComplete():void {
        this.changeStateBackToNormal();

        EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.HIDE_ALL_FREE_SPIN_BULBS));
        EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.HIDE_WIN_ATTENTION_BULBS));

        if(this.extraFreespinsAwarded && this.reelIdd) {
            this.dispatchCompleteEvent(this.reelIdd);
        }
        this._lastRespinningId = -1;
    }

    private onServerDataParsed(data:CreepyCarnivalTwoParsedInitData):void {
        this._respinSymbols = [];

        if(data.restore) {
            this._stickySymbols = data.respinPositions ? data.respinPositions.reduce((acc, currEl) => acc.concat(currEl), []) : [];
            this.calculateLastSpinningId(this._stickySymbols);
        }

    }

    private calculateLastSpinningId(stickySymbols:boolean[]) {
        let _this = this;
        this._stickySymbols.forEach(function(sym, index) {
            if(sym) {
                _this._respinSymbols.push(index);
            }
        });
        if(this._respinSymbols.length > 0) {
            this._lastRespinningId = Math.max(...this._respinSymbols);
        }
    }

    private applyChangeState(sym:StateReelSymbol) {
        return sym.changeState({
            state : CreepyCarnivalTwoGameConfig.instance.SYMBOL_STATES.attention,
            onCompleteCallback : () => {
                sym.changeState({
                    state : CreepyCarnivalTwoGameConfig.instance.SYMBOL_STATES.normal
                });
            }
        })!;
    }

    private onAllReelsStopped():void {
        let sym:StateReelSymbol | null;

        for(let i:number = 0; i < this._symbolWinStates.length; i++) {
            for(let j:number = 0; j < this._symbolWinStates[i].length; j++) {
                if(!this._symbolWinStates[i][j]) {
                    continue;
                }

                sym = Reels.getSymbol(i * 3 + j, 0);

                if(sym === null || !sym.visible) {
                    continue;
                }

                sym.changeState({
                    state : GameConfig.instance.SYMBOL_STATES.normal
                });
                sym.alpha = 1;
            }
        }
    }
}